<script setup lang="ts">
// Minimal shared footer: brand line, the honesty disclaimers, copyright.
withDefaults(
    defineProps<{
        siteName: string
        tagline?: string
    }>(),
    { tagline: 'An independent educational resource — not an HVAC contractor.' },
)

const year = new Date().getFullYear()
</script>

<template>
    <footer class="site-footer">
        <div class="site-content row">
            <div class="brand-block">
                <p class="brand">{{ siteName }}</p>
                <p class="muted small">{{ tagline }}</p>
            </div>
            <div class="legal">
                <p class="muted small">
                    <strong>Serving Northeast Florida</strong> — Jacksonville, St. Augustine,
                    Ponte Vedra, Orange Park, Fernandina Beach &amp; surrounding counties. Other
                    regions are currently unsupported and may not receive a response.
                </p>
                <p class="muted small">
                    Guidance here is informational and never a substitute for an on-site
                    professional inspection. Contact details are shared with a licensed local
                    partner only with your explicit consent — never sold.
                </p>
                <p class="muted small">© {{ year }} {{ siteName }}</p>
            </div>
        </div>
    </footer>
</template>

<style scoped lang="scss">
.site-footer {
    padding: var(--site-space-xl) var(--site-space-lg);
    border-top: 1px solid var(--site-border);
    background: var(--site-bg-alt);
}

.row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--site-space-2xl);

    @media (max-width: 720px) {
        flex-direction: column;
        gap: var(--site-space-md);
    }
}

.brand {
    font-family: var(--site-font-heading);
    font-size: 1.05rem;
    font-weight: 800;
    margin: 0 0 var(--site-space-xs);
}

.brand-block {
    max-width: 22rem;
}

.legal {
    max-width: 34rem;
    text-align: right;

    p {
        margin: 0 0 var(--site-space-xs);
    }

    @media (max-width: 720px) {
        text-align: left;
    }
}

.small {
    font-size: 0.82rem;
}
</style>
